import React from 'react';
import { Modal } from '../../../../common/display/modal/Modal';
import { Benefit } from '../../../../../@types/benefits';
import MieterNetzwerkPng from './images/mieter-netzwerk.png';
import MieterNetzwerkWebp from './images/mieter-netzwerk.webp';
import MieterNetzwerkMobilePng from './images/mieter-netzwerk-mobile.png';
import MieterNetzwerkMobileWebp from './images/mieter-netzwerk-mobile.webp';
import { BenefitModalProps } from '../../../../../@types/benefitModalProps';
import { ProductType } from '../../../../../@types/product';
// import { report } from '../../../../../tracking/tracking';
// import { OverviewTrackingEvents } from '../../../../../tracking/trackingEvents';
import { Msg, useIntl } from '@/i18n';
import { PlusBadge } from '@/components/common/display/plusBadge/PlusBadge';
import { useGetHasProduct } from '@/customHooks/useGetHasProduct.hook';

const styles = {
  overviewTab: { maxWidth: 530 },
};

const OverviewTab = ({ isEntitledPlusRent }: { isEntitledPlusRent: boolean }) => {
  return (
    <div style={styles.overviewTab}>
      <div className='font-heading-xsmall-regular padding-bottom-l'>
        <Msg
          id='benefits.mieterNetzwerk.modal.overview.paragraph1'
          defaultMessage='Entdecke unveröffentlichte Wohnungsangebote im Mieter-Netzwerk.'
        />
      </div>
      <div className='padding-bottom-l'>
        <Msg
          id='benefits.mieterNetzwerk.modal.overview.paragraph2'
          defaultMessage='Werde Teil des Mieter-Netzwerks und erfahre wer gerade auch nach einer neuen Bleibe sucht und welche Wohnungen bald verfügbar werden.'
        />
      </div>
      {!isEntitledPlusRent && (
        <ul className='list-check list-spacing-s'>
          <li data-testid='mieter-plus-label-with-checkmark'>
            <Msg
              id='benefits.mieterNetzwerk.modal.activeMieterPlus'
              defaultMessage='In Suchen+ für Miete enthalten'
              values={{
                Logo: <PlusBadge variant='search' />,
              }}
            />
          </li>
        </ul>
      )}
    </div>
  );
};

const ButtonArea = () => {
  // const handleSubmitCallback = React.useCallback(async () => {
  //   await report(OverviewTrackingEvents.MIETER_NETZWERK.FUNNEL_SUBMIT, isMeinPlus);
  // }, [isMeinPlus]);

  return (
    <div className='align-center'>
      <a
        className='button-secondary button-rounded'
        href='/meinkonto/premium-mitgliedschaft/?cmp_id=10-051527&cmp_name=residential_profile&cmp_position=residential_benefits&cmp_creative=contact_at_top_cta'
        // onClick={handleSubmitCallback}
      >
        <Msg id='benefits.mieterNetzwerk.modal.linkButton' defaultMessage='Discover Mieter Plus' />
      </a>
    </div>
  );
};

export const MieterNetzwerk = ({ isVisible, onClose }: BenefitModalProps) => {
  const { t } = useIntl();
  const isEntitledPlusRent = useGetHasProduct(ProductType.MieterPlus);
  return (
    <Modal
      title={t({
        id: 'benefits.mieterNetzwerk.modal.headline',
        defaultMessage: 'Mieter-Netzwerk',
      })}
      isVisible={isVisible}
      image={MieterNetzwerkPng}
      imageWebp={MieterNetzwerkWebp}
      imageMobile={MieterNetzwerkMobilePng}
      imageMobileWebp={MieterNetzwerkMobileWebp}
      imageAlt={t({
        id: 'benefits.mieterNetzwerk.modal.image',
        defaultMessage: 'Mieter-Netzwerk',
      })}
      imageUseFullWidth={true}
      tabsContent={[
        <OverviewTab key='benefits.mieterNetzwerk.modal.overview' isEntitledPlusRent={isEntitledPlusRent} />,
      ]}
      buttonArea={!isEntitledPlusRent ? <ButtonArea /> : null}
      benefit={Benefit.MIETER_NETZWERK}
      onClose={onClose}
    />
  );
};
